import { LeftPanel } from './panels/LeftPanel';
import { RightPanel } from './panels/RightPanel';
import './CreateView.css';

export const CreateView: React.FC = () => {
  return (
    <div className="create-view">
      <div className="create-view-left">
        <LeftPanel />
      </div>
      <div className="create-view-right">
        <RightPanel />
      </div>
    </div>
  );
};
